import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { UserSettingsFilter } from '@/composable/useUserSettings'

export function postUserSettings(
  payload: UserSettingsFilter
): Promise<AxiosResponse<void>> {
  return instance.post(`/user-setting`, payload)
}
